import { Fragment, FunctionComponent } from 'react'
import { Redirect, useParams } from 'react-router-dom'
import { getComponents } from '../../utils/getComponents'
import { MainLayout } from '@/modules/Activation/components/MainLayout'
import { STEPS_ROUTES } from '../../constants'
import {
  EVENT_NAME_COMPLEMENT,
  ROUTES_WITHOUT_FOOTER_SPACING,
} from './constants'
import useWindowSize from '@/utils/useWindowSize'

const Signup: FunctionComponent = () => {
  const { page } = useParams<{ page: string }>()
  const { isMobile } = useWindowSize()

  const isValidPage = Object?.values(STEPS_ROUTES)?.includes(page)

  if (!isValidPage) return <Redirect to={STEPS_ROUTES.CPF} />

  return (
    <MainLayout
      tagEventName={
        `at_patient_signup${EVENT_NAME_COMPLEMENT[page]}` || 'at_patient_signup'
      }
      additionalFooterSpacing={
        !ROUTES_WITHOUT_FOOTER_SPACING.includes(page) && !isMobile
      }
    >
      <Fragment>{getComponents(page)}</Fragment>
    </MainLayout>
  )
}

export default Signup
